module.exports = __webpack_public_path__ + "static/media/DOone_Practice2_icon.4478e4f1.png";